import { Flex, Typography, Box, omitText } from '@kohler-dsm-library/kohler-core';
import React from 'react';
import classes from './LanguagePicker.module.css.mjs';

const LanguagePicker = ({
  location,
  languagePickerCTA,
  currentLanguage,
  secondLanguageCTA,
  textColor
}) => {
  return /* @__PURE__ */ React.createElement(Flex, { gap: 4, justify: "center", align: "center" }, /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "overline",
      component: "button",
      type: "button",
      textColor: textColor || "var(--content-perma-white)",
      "aria-label": "pick language",
      ...languagePickerCTA
    },
    location,
    " - ",
    currentLanguage
  ), secondLanguageCTA && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { className: classes.divider, backgroundColor: textColor }), /* @__PURE__ */ React.createElement(Typography, { size: "overline", component: "a", ...omitText(secondLanguageCTA), textColor: textColor || "var(--content-perma-white)" }, secondLanguageCTA.text)));
};

export { LanguagePicker };
